// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"logo-markdown"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M1 5H23V19H1V5Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M1 5H23V19H1V5Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M14 12.4975L16.5025 15L19.0031 12.4993M16.5025 9V14.2521M11 15V10C11 9.44772 10.5523 9 10 9L8 9M8 9L8 15M8 9L5 9L5 15","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-logo-markdown')
export default class LogoMarkdownIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'logo-markdown',
    }
  }
}
